import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransition from "../layout/PageTransition";
import DancingWithStars from "../pages/DancingWithStars";
import HeroPage from "../pages/HeroPage";
import RepresentationsPage from "../pages/Representations";
import RepresentationDetail from "../pages/RepresentationDetail";
import PartnersPage from "../pages/PartnersPage";
import ContactPage from "../pages/ContactPage";
import FanAccessPage from "../pages/FanAccessPage";
import ScrollToTop from "../misc/ScrollToTop";
import Disclaimer from "../pages/subPages/Disclaimer";
import Terms from "../pages/subPages/Terms";
import { Navigate } from "react-router-dom";
export default function Router() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <ScrollToTop />
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <PageTransition>
              <HeroPage />
            </PageTransition>
          }
        />
        <Route
          path="/services"
          element={
            <PageTransition>
              <RepresentationsPage />
            </PageTransition>
          }
        />
        <Route
          path="/services/:categoryId"
          element={
            <PageTransition>
              <RepresentationDetail />
            </PageTransition>
          }
        />

        <Route
          path="/fan-access"
          element={
            <PageTransition>
              <FanAccessPage />
            </PageTransition>
          }
        />

        <Route
          path="/dancing-with-the-stars"
          element={
            <PageTransition>
              <DancingWithStars />
            </PageTransition>
          }
        />

        <Route
          path="/partners"
          element={
            <PageTransition>
              <PartnersPage />
            </PageTransition>
          }
        />

        <Route
          path="/contact"
          element={
            <PageTransition>
              <ContactPage />
            </PageTransition>
          }
        />

        <Route
          path="/privacy-policy"
          element={
            <PageTransition>
              <Disclaimer />
            </PageTransition>
          }
        />
        <Route
          path="/terms"
          element={
            <PageTransition>
              <Terms />
            </PageTransition>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
}
